import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {
  DIRECTORY,
  HEADER,
  DIRECTORY_SEARCH,
  URL_SERVER
} from '../../utils/constants';
import * as Request from '../../service/data-info-chart/requestsUtil';
import {
  Button,
  Input,
  Col,
  Form,
  FormGroup
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import Axios from 'axios';

let Loader = require('react-loader');

class directoryTable extends Component {

  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      data: [],
      name: '',
      loaded: false,
    };
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
    this.search();
  }

  search() {
    Request.getFetch(DIRECTORY_SEARCH + this.state.name)
      .then((resp) => {
        this.setState({
          data: resp,
          loaded: true,
        });
      });
  }

  render() {

    const headerStyle = {
      background: HEADER.BACKCOLOR,
      color: HEADER.COLOR,
      fontSize: HEADER.FONTSIZE,
      textAlign: 'left'
    };

    let header = [{
      Header: 'Nombre',
      accessor: 'name',
      headerStyle: headerStyle
    },
      {
        Header: 'Unidad de negocio',
        accessor: 'businessUnit',
        headerStyle: headerStyle
      },
      {
        Header: 'Extensión',
        accessor: 'ext',
        headerStyle: headerStyle
      },
      {
        Header: 'Celular',
        accessor: 'phone',
        headerStyle: headerStyle
      },
    ];

    return (<div className='container-fluid'>
      <div className='container pt-5 pb-5 pl-0 pr-0'>
        <div className='mt-5 mb-5'>
          <FormGroup row>
            <Col xs={9} sm={10} md={11}>
              <Input type="text" name="name" id="search" placeholder="Aquien buscamos?..."
                     value={this.state.name} onChange={this.handleChange}/>
            </Col>
            <Col xs={1}>
              <Button onClick={this.search} color="secondary">🔍</Button>
            </Col>
          </FormGroup>
        </div>
        <div className='container-fluid table-title'>
          Directorio
        </div>
        <div>
          <ReactTable
            className={'-striped'}
            columns={header}
            data={this.state.data.data}
            showPageJump={true}
            noDataText="¡No hay personal en el directorio!"
            defaultPageSize={10}
            showPagination={true}
            previousText={'Anterior'}
            pageText={'Página'}
            ofText={'de'}
            rowsText={'registros'}
            nextText={'Siguiente'}
            sortable={false}
            pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
            manual // informs React Table that you'll be handling sorting and pagination server-side
            onFetchData={(state) => {
              // show the loading overlay
              this.setState({ loaded: false });
              // fetch your data
              Axios.get(URL_SERVER + DIRECTORY + state.page + '&size=' + state.pageSize, {
                method: 'get',
                headers: { 'Authorization': sessionStorage.getItem('token') },
                page: state.page,
                pageSize: state.pageSize,
                sorted: state.sorted,
                filtered: state.filtered
              })
                .then((res) => {
                  // Update react-table
                  this.setState({
                    data: res.data,
                    pages: res.data.totalPages,
                    loaded: true,
                  });
                });
            }}
          />
        </div>
        <Loader loaded={this.state.loaded}/>
      </div>
    </div>);

  }
}

export default directoryTable;



// WEBPACK FOOTER //
// ./src/components/tables/directoryTable.js